import { resolvePreferredCardProcessor } from './paymentProcessor.js';
export const DEFAULT_AFFIRM_MIN_AMOUNT_USD = 50;
export function getAffirmMinAmountUsd(integrations) {
    const raw = integrations?.stripe?.affirmMinAmount;
    if (typeof raw === 'number' && raw > 0) {
        return raw;
    }
    return DEFAULT_AFFIRM_MIN_AMOUNT_USD;
}
export function isAffirmEnabledInSettings(integrations) {
    const stripe = integrations?.stripe;
    return Boolean(stripe?.affirmEnabled === true &&
        stripe.isEnabled !== false &&
        stripe.publishableKey &&
        stripe.secretKey);
}
/** Affirm is available only when Stripe is the active processor and affirm is enabled. */
export function isAffirmFinancingAvailable(integrations, amountDollars) {
    if (!integrations || amountDollars < getAffirmMinAmountUsd(integrations)) {
        return false;
    }
    if (resolvePreferredCardProcessor(integrations) !== 'stripe') {
        return false;
    }
    return isAffirmEnabledInSettings(integrations);
}
export function amountDollarsToCents(amountDollars) {
    return Math.round(Math.max(0, amountDollars) * 100);
}
export function amountCentsToDollars(amountCents) {
    return Math.round(amountCents) / 100;
}
//# sourceMappingURL=affirmFinancing.js.map